class TnfCarouselVideo extends HTMLElement {
  /** @type {MutationObserver | undefined} */
  #observer;

  connectedCallback() {
    const slide = this.closest('slideshow-slide');

    if (!slide || slide.getAttribute('aria-hidden') === 'false') {
      this.#loadVideo();
      return;
    }

    this.#observer = new MutationObserver(() => {
      if (slide.getAttribute('aria-hidden') !== 'false') return;
      this.#loadVideo();
      this.#observer?.disconnect();
    });
    this.#observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #loadVideo() {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const selector = isMobile ? '.tnf-carousel__video--mobile' : '.tnf-carousel__video--desktop';
    const fallbackSelector = isMobile ? '.tnf-carousel__video--desktop' : '.tnf-carousel__video--mobile';

    /** @type {HTMLVideoElement | null} */
    const target = this.querySelector(selector) ?? this.querySelector(fallbackSelector);

    if (!target) return;

    target.load();
    target.play().catch(() => {});
  }
}

if (!customElements.get('tnf-carousel-video')) {
  customElements.define('tnf-carousel-video', TnfCarouselVideo);
}
